export class LiveChatError extends Error {
  public context: Record<string, unknown>;

  constructor(message: string, context: Record<string, unknown> = {}) {
    super(message ?? 'Unknown LiveChatError');

    this.name = 'LiveChatError';
    this.context = context;

    Object.setPrototypeOf(this, LiveChatError.prototype);
  }
}

export function scriptLoadError(event: Event | string) {
  const src =
    typeof event === 'string'
      ? '[unknown source]' // Legacy browser error, super rare, but TS expects typeof event is string or Event
      : event?.target instanceof HTMLScriptElement
        ? event.target.src
        : '[unknown source]';

  throw new LiveChatError(`Load via script tag failed: ${src}`);
}
